<template>
	<div class="box">
		<div class="row">
			<div class="col-7">
				<e-select
					id="status_selected"
					v-model="status_selected"
                    track-by="code"
					label="label"
					:placeholder="$t('monte.semence.selectionnez_statut')"
					:selectedLabel="$t('global.selected_label')"
					:options="all_status"
					:multiple="true"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>
			<div class="col-3">
				<e-select
					id="type_date"
					v-model="type_date"
                    track-by="code"
					label="label"
					:placeholder="$t('monte.semence.selectionnez_type_date')"
					:selectedLabel="$t('global.selected_label')"
					:options="all_type_date"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>
			<div class="col-2">
				<b-button variant="primary" block @click="load_commandes">{{ $t('global.rechercher') }}</b-button>
			</div>
			<div class="col-12">
	            <DateRangeV2
            		v-if="type_date"
	                :start.sync="start_date"
	                :end.sync="end_date"
	                :dateSelect="true"
	                :periodToShow="['personalise','jour','mois','mois_dernier']"
	                :submitButton="false"
	            />
			</div>
		</div>

		<CustomTable
            ref="table"
            id_table="ca_expeditions_stallion"
            primaryKey="horse_id"
            :items="commandes"
            :busy.sync="table_busy"
            :checkboxes="false"
        />

        <AddCommande ref="add_commande" :stallion_id="horse_id" @submit="load_commandes" />
	</div>
</template>

<script type="text/javascript">
	import Semence from "@/mixins/Semence.js"
    import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'StallionsCommandes',
		mixins: [Semence, Navigation],
		props: ['horse_id'],
		data () {
			return {
				table_busy: false,
				commandes: [],
				all_status: [{
					code: 5,
					label: this.getTrad('monte.semence.status.waiting')
				},{
					code: 6,
					label: this.getTrad('monte.semence.status.expedie')
				},{
					code: 7,
					label: this.getTrad('monte.semence.status.livre')
				},{
					code: 8,
					label: this.getTrad('monte.semence.status.facture')
				}],
				status_selected: [],
				all_type_date: [{
					code: 'semenceexpedition_enlevement_date',
					label: this.getTrad('monte.semence.date.semenceexpedition_enlevement_date')
				}],
				type_date: null,
				start_date: new Date(new Date().setDate(new Date().getDate() - 7)),
				end_date: new Date(),
                events_tab: {
					'TableAction::goToAddCommandeSemence': () => {
						this.$refs.add_commande.openModal()
					},
				},
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.status_selected = this.all_status.filter(st => [5].includes(st.code))
				this.load_commandes()
			},
			async load_commandes() {
				this.table_busy = true
				let commandes = await this.getCommandeStallion(this.horse_id, this.status_selected.map(st => st.code), this.type_date, this.start_date, this.end_date)
				commandes.forEach(exp => {
					exp.statut = this.getTrad('monte.semence.status.'+exp.semenceexpedition_status)
					exp.semenceexpedition_qte += ' ' + (exp.semenceexpedition_dose ? this.getTrad('monte.doses') : this.getTrad('monte.paillettes'))
				})
				this.commandes = commandes
				this.table_busy = false
			}
		},

		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
			DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2'),
			AddCommande: () => import('@/components/Semence/AddCommande')
		}
	}

</script>